import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccountBalanceOutlinedIcon from "@material-ui/icons/AccountBalanceOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function MultipleAccounts(props) {
  const classes = useStyles();
  // const [expanded, setExpanded] = React.useState(false);
  const [mask, setUnmask] = React.useState(false);
  // const handleChange = (panel) => (event, isExpanded) => {
  //   setExpanded(isExpanded ? panel : false);
  // };

  let accounts;
  // let account_number;
  // let multipleAccountInfo = props.multipleAccountData.map((item, i) => {
  //   // console.log("Multiple Accounts Value: ", item);
  //   // console.log("ACCOUNTS: ", item.accounts);
  //   accounts = item.accounts;

  //   // account_number = mask
  //   //   ? item.accounts[i].account_number
  //   //   : "*".repeat(item.accounts[i].account_number.length);
  // });

  /**
   * 1. Masking Logic
   *    a) let text = num.substring(0, num.length - 4).replace(/\d/g,"*") + num.substring(num.length, num.length - 4); ==> ********2001
   *    b) "*".repeat(num.toString().length) ==> ************
   */

  const handleMasking = (e) => {
    // text = '*'.repeat(text.length);
    e.preventDefault();
    setUnmask(!mask);
  };
  return (
    <div className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70">
      {/* // <div className={classes.root}> */}
      {accounts.map((e, i) => (
        <Accordion key={i}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            // aria-controls="panel1bh-content"
            // id="panel1bh-header"
            aria-label="Expand"
            aria-controls="additional-actions3-content"
            id="additional-actions3-header"
          >
            {/* <Typography className={classes.heading}>Account Number: {e.account_number}</Typography> */}
            {/* <Typography>
            <AccountBalanceOutlinedIcon /> 
            {e.account_number}
            </Typography> */}
            <FormControlLabel
              // control={<AccountBalanceOutlinedIcon />}
              // control={<VisibilityOutlinedIcon onChange={handleMasking} />}
              onClick={(event) => event.stopPropagation()}
              onFocus={(event) => event.stopPropagation()}
              control={
                mask ? (
                  <VisibilityOutlinedIcon onClick={(e)=>{handleMasking(e)}} />
                ) : (
                  <VisibilityOffOutlinedIcon onClick={(e)=>{handleMasking(e)}} /> 
                )
              }
              // label={account_number} "*".repeat(num.toString().length)
              label={
                mask ? e.account_number : e.account_number.toString().substring(0, e.account_number.toString().length - 4).replace(/\d/g,"*") + e.account_number.toString().substring(e.account_number.toString().length, e.account_number.toString().length - 4)
              }
            />
          </AccordionSummary>
          <AccordionDetails>
            <Typography className={classes.secondaryHeading}>
              Account Balance: ₹{e.account_balance}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
    // </div>
  );
}
